import React, { useState } from 'react'
import { Avatar, Button, Card, List, Tag, Tabs, Typography } from 'antd'
import { CalendarOutlined, FilterOutlined, TeamOutlined, WalletOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileInvoiceDollar, faChartLine } from '@fortawesome/free-solid-svg-icons'
import { getStatusColor, handleDashboardCardClick } from '../utils'
import CoreEnums from '../../../../../core/utils/enums'
import dashboardStyles from '../styles/dashboardStyles'
import useDashboardData from '../hooks/useDashboardData'

const { Text } = Typography

const RecentActivity = ({ recentInvoices = [], upcomingPayments = [], style = {} }) => {
  const [activeTab, setActiveTab] = useState('1')

  const { handleEditInvoice } = useDashboardData()

  // Custom empty state component for recent invoices
  const EmptyInvoices = () => (
    <div style={{ textAlign: 'center', padding: '32px 0' }}>
      <div
        style={{
          fontSize: '48px',
          color: '#1890ff',
          margin: '0 auto 16px',
          opacity: 0.7
        }}
      >
        <FontAwesomeIcon icon={faFileInvoiceDollar} />
      </div>
      <Text style={{ fontSize: '16px', color: '#8c8c8c' }}>No recent invoices</Text>
      <div style={{ marginTop: '8px' }}>
        <Text type='secondary' style={{ fontSize: '14px' }}>
          Create your first invoice to get started
        </Text>
      </div>
    </div>
  )

  return (
    <Card
      title='Recent Activity'
      extra={
        <Button type='link' icon={<FilterOutlined />}>
          Filter
        </Button>
      }
      style={{ ...dashboardStyles.card, height: '100%', display: 'flex', flexDirection: 'column', ...style }}
      bodyStyle={{ flex: 1, overflow: 'auto', paddingBottom: 0 }}
    >
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: '1',
            label: 'Recent Invoices',
            children: (
              <>
                {recentInvoices && recentInvoices.length > 0 ? (
                  <>
                    <List
                      dataSource={recentInvoices}
                      renderItem={(item) => {
                        return (
                          <List.Item
                            key={item.invoiceNo}
                            actions={[
                              <Button type='link' key='view' onClick={() => handleEditInvoice(item)}>
                                View
                              </Button>,
                              <Button type='link' key='edit' onClick={() => handleEditInvoice(item)}>
                                Edit
                              </Button>
                            ]}
                          >
                            <List.Item.Meta
                              avatar={
                                <Avatar
                                  icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}
                                  style={{ backgroundColor: '#1890ff' }}
                                />
                              }
                              title={
                                <a href='javascript:void(0)'>
                                  {item.invoiceNo} - {item.patientRecord.firstName} {item.patientRecord.lastName}
                                </a>
                              }
                              description={
                                <span>
                                  <CalendarOutlined /> {item.createdAt}
                                </span>
                              }
                            />
                            <div>
                              <div style={{ fontWeight: 'bold' }}>
                                R{' '}
                                {item.billingRecords
                                  .map((record) => record.total)
                                  .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
                                  .toFixed(2)}
                              </div>
                              <Tag color={getStatusColor(item.status)}>
                                {item.status ? item.status.toUpperCase() : 'PENDING'}
                              </Tag>
                            </div>
                          </List.Item>
                        )
                      }}
                    />
                    <div style={{ textAlign: 'center', marginTop: 16 }}>
                      <Button
                        type='primary'
                        onClick={() => handleDashboardCardClick(CoreEnums.tabKeys.INVOICES)}
                        style={dashboardStyles.primaryButton}
                      >
                        View All Invoices
                      </Button>
                    </div>
                  </>
                ) : (
                  <EmptyInvoices />
                )}
              </>
            )
          }
        ]}
      />
    </Card>
  )
}

export default RecentActivity
